import { connect } from "react-redux";
import EmailCampaignsPage from "../components/email-campaigns/EmailCampaignsPage";

const mapStateToProps = (state) => ({
  userId: state.catalogReducer?.user?.userId,
});

export default connect(mapStateToProps)(EmailCampaignsPage);
